module.exports = __webpack_public_path__ + "static/media/noemia.ca4cfa9e.png";